export default class templates {
    constructor() {
        return {
            template: require("../../../../views/maileditor/templates.html"),
            replace: true,
            restrict: 'E',
            controller: SelectTemplateCtrl,
            controllerAs: 'selector'
        }
    }
};

class SelectTemplateCtrl {
    constructor($scope, Template) {
        this._scope = $scope;
        
        this.templateRepo = Template; 
        
        this.isVisible = false;

        this.templates = [];
        this.templatesByType = {};

        this.templateRepo.get().then((templates) => {
            angular.forEach(templates.data, (template) => {
                if (template.templateType) {
                    let typeName = template.templateType.data.name;
                    if (!this.templatesByType.hasOwnProperty(typeName)) {
                        this.templatesByType[typeName] = [];
                    }
                    this.templatesByType[typeName].push(template);
                } else {
                    this.templates.push(template);
                }
            });
        });

        this._scope.$on('mailEditor:templateSelector:show', () => {
            this.isVisible = true;
        });

        this._scope.$on('mailEditor:state:init', (event, data) => {
            this.currentTemplate = data.dispatcher.email.email_template_id;
        });
    }

    setTemplate(template) {
        this.isVisible = false; // Hide.
        this.currentTemplate = template.id;
        this._scope.$emit('mailEditor:template:selected', template.id);
    }

    backToEditor() {
        this.isVisible = false;
        this._scope.$emit('mailEditor:template:notChanged');
    }
}
